import { useFilteredSims } from 'lib/hooks/sim/sim.queries';
import React, { PropsWithChildren } from 'react';
import { useYourSimsContext } from 'views/YourSiMs/hooks';

/**
 * Refactored Functional Component for Sim List top actions (Not Fully Refactored)
 *
 * @description
 * As of now, this component is not the fully refactored version of Sim List Actions described in the YourSims/component.js file.
 * It shows the sim count display to sync with the react query store instead of using local state.
 *
 * @todo Should eventually have all the actions/buttons in this component. (uses children as of now)
 */
function SimListActions({ children }: PropsWithChildren<{}>) {
  const { oldAllChecked, onSimRowCheck, getFilteredSimsParams } =
    useYourSimsContext();
  const { data: filteredSimsData, isLoading } = useFilteredSims(
    getFilteredSimsParams()
  );

  if (isLoading) return null;

  return (
    <div className="all-filters">
      <div className="select-all">
        <label className="custom-checkbox-only">
          <input
            type="checkbox"
            className="custom-checkbox--input"
            name="duplex"
            checked={oldAllChecked}
            onChange={() => onSimRowCheck({}, 'all')}
          />
          <span className="checkmark-only"></span>
        </label>
      </div>

      <div className="sims-action">{children}</div>

      <SimCountDisplay totalCount={filteredSimsData?.total ?? 0} />
    </div>
  );
}

function SimCountDisplay(props: { totalCount: number }) {
  const { oldPageNumber, simsPerPage } = useYourSimsContext();
  const { totalCount } = props;

  // Calculate the lower bound of the current page's sim count
  // Uses Math.max to ensure it's never less than 1
  const lowerCount = Math.max((oldPageNumber - 1) * simsPerPage + 1, 1);

  // Calculate the upper bound of the current page's sim count
  // Uses Math.min to ensure it doesn't exceed the total count
  const upperCount = Math.min(simsPerPage * oldPageNumber, totalCount);

  return (
    <div className="filter-page-number ml-auto">
      {lowerCount}-{upperCount} of {totalCount}
    </div>
  );
}

export default SimListActions;
